<ng-template #loadingGeneral>

  <mat-spinner class="center"></mat-spinner>
  <p class="center">Loading...</p>

</ng-template>

<ng-template #loadingItem>
  <mat-progress-bar class="center" mode="indeterminate"></mat-progress-bar>
</ng-template>


<div fxLayout="column">


  <ng-container *ngIf="dataSource; else loadingGeneral">

    <div class="w-100 mb-1" fxLayout="row" fxLayoutAlign="center center">

      <mat-form-field *ngIf="dataSource.data.length > 1" class="mb-0">
        <mat-label>Search</mat-label>
        <input #input (keyup)="applyFilters(input.value)" matInput placeholder="">
      </mat-form-field>
      <span fxFlex></span>
      <button *ngIf="!embeddedLayout" (click)="createSim()" mat-button color="primary">New sim</button>
    </div>

    <mat-progress-bar *ngIf="loading" class="center" mode="indeterminate"></mat-progress-bar>
    <table (matSortChange)="doSortSims($event)" [dataSource]="dataSource" class="w-100 mat-elevation-z2" mat-table
      multiTemplateDataRows matSort>

      <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

      <!-- Position Column -->
      <ng-container matColumnDef="id">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>ID</th>
        <td *matCellDef="let element" mat-cell> {{element.id}} </td>
      </ng-container>

      <!-- Expiration Date Column -->
      <ng-container matColumnDef="expirationDate">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Expiration Date</th>
        <td *matCellDef="let element" mat-cell> {{element.expirationDate | date:"dd/MM/yyyy"}} </td>
      </ng-container>

      <!-- Identifier Column -->
      <ng-container matColumnDef="identifier">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Identifier</th>
        <td *matCellDef="let element" mat-cell> {{element.identifier}} </td>
      </ng-container>

      <!-- Data Usage Column -->
      <ng-container matColumnDef="dataUsage">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Data Usage</th>
        <td *matCellDef="let element" mat-cell> {{element.dataUsage}} </td>
      </ng-container>

      <!-- Max Data Usable Column -->
      <ng-container matColumnDef="maxDataUsable">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Max Data Usable</th>
        <td *matCellDef="let element" mat-cell> {{element.maxDataUsable}} </td>
      </ng-container>

      <!-- Sim Operator Column -->
      <ng-container matColumnDef="simOperator">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Sim Operator</th>
        <td *matCellDef="let element" mat-cell> {{element.simOperator}} </td>
      </ng-container>

      <!-- Contact Phone 1 Column -->
      <ng-container matColumnDef="contact1phone">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Contact Phone 1</th>
        <td *matCellDef="let element" mat-cell> {{element.contact1phone}} </td>
      </ng-container>

      <!-- Monthly Fee Column -->
      <ng-container matColumnDef="monthlyFee">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Monthly Fee</th>
        <td *matCellDef="let element" mat-cell> {{element.monthlyFee}} </td>
      </ng-container>

      <!-- Box Column -->
      <ng-container matColumnDef="box">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Box</th>
        <td *matCellDef="let element" mat-cell> {{element.box?.identifier}} </td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Status</th>
        <td *matCellDef="let element" mat-cell> {{element.status | splitCamelCase }} </td>
      </ng-container>

      <!-- Action -->
      <ng-container matColumnDef="action">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let element" mat-cell class="text-right">
          <ng-container *ngIf="!disabledItemId.includes(element.id); else loadingItem">
            <button (click)="details(element)" [disabled]="disabled" mat-icon-button matTooltip="Show details">
              <mat-icon>visibility</mat-icon>
            </button>
            <ng-container *ngIf="!embeddedLayout">
              <button (click)="editSim(element)" [disabled]="disabled" mat-icon-button matTooltip="Edit sim">
                <mat-icon>edit</mat-icon>
              </button>
              <ng-container
                *ngIf="!element.box || element.box.status == boxStatuses.assigned || element.box.status == boxStatuses.onTheShelf || element.box.status == boxStatuses.broken || element.box.status == boxStatuses.toBeConfigured">
                <button *awIsInAnyRole="[roles.admin]" (click)="deleteSim(element)" [disabled]="disabled"
                  mat-icon-button matTooltip="Delete sim">
                  <mat-icon>delete</mat-icon>
                </button>
              </ng-container>

            </ng-container>
          </ng-container>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns:  displayedColumns" mat-row></tr>
      <!--      <tr *matRowDef="let row; columns: ['expandedDetail']"-->
      <!--          [fxShow]="expandedContractEventsHistory?.id === row.id" mat-row></tr>-->


      <tr *matNoDataRow class="mat-row">
        <td [colSpan]="displayedColumns.length" class="mat-cell text-center">
          No sims found
        </td>
      </tr>

    </table>
  </ng-container>

  <mat-paginator #paginatorSims [fxShow]="dataSource && dataSource.data.length > 10" class="mat-elevation-z1"
    [pageSizeOptions]="[5, 10, 20]" [pageSize]="10" showFirstLastButtons></mat-paginator>
</div>